/**
 * Modular What's New entries for the "aiAssistant" module: answers appear progressively. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const aiAssistantEntries = [
  {
    id: 'assistant-progressive-answers-2026-10',
    module: 'aiAssistant',
    routes: ['AIAssistantScreen'],
    date: '2026-10-20',
    version: '4.15.1',
    global: false,
    type: 'improvement',
    title: {
      en: "💬 Assistant answers now appear as they are written",
      hu: "💬 Az asszisztens válaszai írás közben jelennek meg",
      de: "💬 Antworten des Assistenten erscheinen jetzt Wort für Wort",
      cn: "💬 助手的回答现在会边写边显示",
      ro: "💬 Răspunsurile asistentului apar acum pe măsură ce sunt scrise",
      svn: "💬 Odgovori pomočnika se zdaj prikazujejo sproti",
    },
    body: {
      en: "Instead of a long wait and a wall of text, the assistant now reveals its answer progressively with a typing indicator, so you can start reading at once. Formatting such as bold text and links stays intact while it types, and earlier messages open instantly.",
      hu: "A hosszú várakozás és a szövegfal helyett az asszisztens most fokozatosan, gépelésjelzővel írja ki a választ, így rögtön elkezdheted olvasni. A formázás, például a félkövér szöveg és a hivatkozások, gépelés közben is épségben marad, a korábbi üzenetek pedig azonnal megnyílnak.",
      de: "Statt langer Wartezeit und Textwand blendet der Assistent seine Antwort jetzt schrittweise mit einer Tippanzeige ein, sodass Sie sofort lesen können. Formatierungen wie Fettdruck und Links bleiben dabei intakt, frühere Nachrichten erscheinen sofort.",
      cn: "助手不再让你久等后一次性给出大段文字，而是带着输入指示逐步显示回答，你可以立即开始阅读。加粗和链接等格式在输入过程中保持完整，历史消息则即时显示。",
      ro: "În loc de o așteptare lungă și un zid de text, asistentul își dezvăluie acum răspunsul treptat, cu un indicator de scriere, ca să poți începe să citești imediat. Formatarea, precum textul aldin și linkurile, rămâne intactă în timpul scrierii, iar mesajele anterioare se deschid instantaneu.",
      svn: "Namesto dolgega čakanja in zidu besedila pomočnik zdaj odgovor razkriva postopoma z indikatorjem tipkanja, da lahko takoj začnete brati. Oblikovanje, kot sta krepko besedilo in povezave, ostane med tipkanjem nespremenjeno, prejšnja sporočila pa se odprejo takoj.",
    },
  },
];

export default aiAssistantEntries;
